import { ProductType } from '@gn-audio/jss-core';

import { usePageProduct } from 'common/PageProductContext/pageProductContext';
import { Price } from 'composables/Product/Buy/Price/Price';

export const ProductPagePrice = () => {
  const { price, productType } = usePageProduct();

  if (!price) return null;

  const type: ProductType = productType === 'Family' ? ProductType.Family : ProductType.Group;
  return (
    <div>
      <Price price={price} productType={type}></Price>
    </div>
  );
};
